if (!window.collectionSiblingNavFadeInit) {
  window.collectionSiblingNavFadeInit = true;

  var updateFade = function (row) {
    var wrap = row.closest('.collection-sibling-nav__row-wrap');
    if (!wrap) return;
    var maxScroll = row.scrollWidth - row.clientWidth;
    wrap.classList.toggle('is-scrollable-start', row.scrollLeft > 1);
    wrap.classList.toggle('is-scrollable-end', row.scrollLeft < maxScroll - 1);
  };

  var rows = function () {
    return document.querySelectorAll('.collection-sibling-nav__row');
  };

  var init = function () {
    rows().forEach(function (row) {
      updateFade(row);
      row.addEventListener(
        'scroll',
        function () {
          updateFade(row);
        },
        { passive: true }
      );
    });
  };

  window.addEventListener('resize', function () {
    rows().forEach(updateFade);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}
